module.exports = __webpack_public_path__ + "img/slider-10.b007ee6d.jpg";